import { useNavigate } from 'react-router-dom';
import NavbarComponent from '../landing_page/landing_page_components/NavbarComponent';

export default function TermsAndConditions() {
    const navigate = useNavigate();

    return (
        <>
            <div className="pt-[1.88rem] px-[2.5rem] w-full">
                <NavbarComponent handleNavigate={() => navigate('/')} />
            </div>
            <div className="flex flex-col w-full px-[5rem] py-[3rem]">
                <span className="heading_1">Terms and Conditions</span>
                <span className="paragraph_1 mt-[1.5rem]">Chamify Africa</span>

                <span className="mt-[1.5rem]">
                    Welcome to Chamify Africa. By accessing or using our platform, website, or mobile application, you agree to comply with and be bound by these Terms and
                    Conditions. Please read them carefully before using our services.
                </span>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">1. About Chamify Africa</span>
                    <span className="label_2">
                        Chamify Africa is a digital platform designed to support chamas, savings groups, and community financial management through technology-driven solutions.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">2. Acceptance of Terms</span>
                    <span className="label_2">By creating an account or using Chamify Africa, you confirm that:</span>
                    <span className="paragraph_1">● You are at least 18 years old or using the platform under authorized supervision.</span>
                    <span className="paragraph_1">● The information you provide is accurate and complete.</span>
                    <span className="paragraph_1">● You agree to comply with all applicable laws and regulations.</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">3. User Accounts</span>
                    <span className="label_2">Users are responsible for:</span>
                    <span className="paragraph_1">● Maintaining the confidentiality of their login credentials.</span>
                    <span className="paragraph_1">● Ensuring all account information remains accurate.</span>
                    <span className="paragraph_1">● Any activity conducted under their account.</span>
                    <span className="paragraph_1">
                        Chamify Africa reserves the right to suspend or terminate accounts involved in fraud, misuse, or violation of these terms.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">4. Use of the Platform</span>
                    <span className="label_2">Users agree not to:</span>
                    <span className="paragraph_1">● Use the platform for illegal or fraudulent activities.</span>
                    <span className="paragraph_1">● Upload false, harmful, or misleading information.</span>
                    <span className="paragraph_1">● Attempt unauthorized access to systems or data.</span>
                    <span className="paragraph_1">● Disrupt the functionality or security of the platform.</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">5. Payments and Transactions</span>
                    <span className="label_2">
                        Chamify Africa may facilitate financial tracking and payment-related functionalities. Users are responsible for verifying all transaction details before
                        confirmation. Chamify Africa shall not be liable for losses arising from:
                    </span>
                    <span className="paragraph_1">● Incorrect user-entered information</span>
                    <span className="paragraph_1">● Delayed network services</span>
                    <span className="paragraph_1">● Third-party payment failures</span>
                    <span className="paragraph_1">● Unauthorized account access caused by user negligence</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">6. Data and Privacy</span>
                    <span className="label_2">
                        Your personal information will be handled in accordance with our Privacy Policy. By using Chamify Africa, you consent to the collection and use of your
                        information as described therein.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">7. Intellectual Property</span>
                    <span className="label_2">
                        All content, branding, logos, software, and materials on Chamify Africa remain the intellectual property of Chamify Africa unless otherwise stated.
                        Unauthorized reproduction or distribution is prohibited.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">8. Limitation of Liability</span>
                    <span className="label_2">
                        Chamify Africa provides its services on an “as available” basis and does not guarantee uninterrupted or error-free access. To the maximum extent permitted
                        by law, Chamify Africa shall not be liable for indirect, incidental, or consequential damages arising from use of the platform.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">9. Modifications</span>
                    <span className="label_2">
                        Chamify Africa reserves the right to update or modify these Terms and Conditions at any time. Continued use of the platform after updates constitutes
                        acceptance of the revised terms.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">10. Termination</span>
                    <span className="label_2">
                        We reserve the right to suspend or terminate access to users who violate these Terms and Conditions or engage in activities harmful to the platform or
                        other users.
                    </span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">11. Governing Law</span>
                    <span className="label_2">These Terms and Conditions shall be governed in accordance with the laws of Kenya.</span>
                </div>

                <div className="flex flex-col mt-[1.5rem] gap-[.62rem]">
                    <span className="heading_5 mb-[.52rem]">12. Contact Information</span>
                    <span className="label_2">For questions or concerns regarding these Terms and Conditions, please contact:</span>
                    <span className="paragraph_1">Email: chamify@spa-limited.com</span>
                    <span className="paragraph_1">Phone: 0141940343</span>
                    <span className="paragraph_1">Website: https://chamify.africa/</span>
                </div>

                <span className="paragraph_2 mt-[3rem]">Thank you for using Chamify!</span>
            </div>
        </>
    );
}
